const getProcessingStatus = lot => {
  const steps = lot?.processing_steps || [];

  // 1. If no processing steps, return "Process yet to be defined"
  if (steps.length === 0) {
    return 'Process yet to be defined';
  }

  // Map over processing_steps to find active/in-progress step
  const activeOrInProgressStep = steps.find(step => step.status === 'Active' || step.status === 'In Progress');

  // 2. If a process is active or in progress, show that process name
  if (activeOrInProgressStep) {
    // Special handling for Fermentation with hours
    if (activeOrInProgressStep.name === 'Fermentation' && activeOrInProgressStep.data?.start_at) {
      const startedAt = activeOrInProgressStep.data.start_at;
      const hours = Math.floor((Date.now() - new Date(startedAt)) / (1000 * 60 * 60));
      return `Fermentation since ${hours}hrs`;
    }

    return activeOrInProgressStep.name; // Pulping, Washing, Fermentation, etc.
  }

  // 3. Check if any process has started (not all are "Yet to start" or null/undefined)
  const hasStartedProcess = steps.some(step => step.status && step.status !== 'Yet to start' && step.status !== null);

  // 4. If no process has started (all are "Yet to start" or null), return "Yet to start"
  if (!hasStartedProcess) {
    return 'Yet to start';
  }

  // 5. Check if all are completed
  const allCompleted = steps.every(step => step.status === 'Completed');
  if (allCompleted) {
    return 'Processing completed';
  }

  // 6. Fallback - find next step that's yet to start
  const nextStep = steps.find(step => step.status === 'Yet to start' || !step.status);
  if (nextStep) {
    return `${nextStep.name} yet to start`;
  }

  // 7. Final fallback
  return 'Process yet to start';
};

export default getProcessingStatus;
